import MultiquoteDebugCompanyLogs from './MultiquoteDebugCompanyLogs'

class MultiquoteDebugData {
    constructor(quotes, emissions) {
        this.quotes = quotes
        this.emissions = emissions
    }

    static fromJson({ quotes = [], emissions = [] } = {}) {
        return new MultiquoteDebugData(
            quotes.map((entry) => MultiquoteDebugCompanyLogs.fromJson(entry)),
            emissions.map((entry) => MultiquoteDebugCompanyLogs.fromJson(entry))
        )
    }

    static fromApiResponse(response) {
        const { data: axiosData } = response ?? {}
        const payload = axiosData?.data ?? axiosData ?? {}

        return MultiquoteDebugData.fromJson(payload)
    }
}

export default MultiquoteDebugData
